import {
	CLEAR_GAME,
	GET_OR_CREATE_GAME_COMPLETE,
	INIT_GAME_DATA,
	INIT_GAME_DATA_COMPLETE
} from "./constants";
import { ON_ERROR } from "../app/constants";

const initialState = {
	game: null,
	isLoading: false
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case INIT_GAME_DATA:
			return {
				...state,
				game: null,
				isLoading: true
			};
		case CLEAR_GAME:
		case INIT_GAME_DATA_COMPLETE:
		case GET_OR_CREATE_GAME_COMPLETE:
		case ON_ERROR:
			return {
				...state,
				...payload,
				isLoading: false
			};
		default:
			return state;
	}
};

export default reducer;
